import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function Problem() {
  const phrases = ['No sé qué desayunar.', 'No sé qué comer.', 'Siempre termino haciendo lo mismo.', 'Extraño compartir una pizza.', 'Extraño comer pan.', 'Extraño los postres.'];
  return <section className="py-24 md:py-32 px-6 bg-white" data-id="element-133">
      <div className="max-w-4xl mx-auto" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-135">
          <h2 className="text-4xl md:text-6xl font-serif font-black text-gray-900 mb-6 leading-tight" data-id="element-136">
            LO PEOR NO ES LA DIABETES.
          </h2>
          <h3 className="text-2xl md:text-4xl font-serif font-bold text-gray-600" data-id="element-137">
            Es no saber qué cocinar todos los días.
          </h3>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-6 mb-20" data-id="element-138">
          {phrases.map((phrase, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-center gap-4 bg-red-50/50 p-6 rounded-2xl border border-red-100" data-id="element-139">
              <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0" data-id="element-140">
                <X className="w-5 h-5 text-red-500" data-id="element-141" />
              </div>
              <p className="text-xl md:text-2xl font-serif font-medium text-gray-800" data-id="element-142">
                "{phrase}"
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-primary text-white p-10 md:p-16 rounded-[2.5rem] text-center shadow-2xl shadow-primary/30" data-id="element-143">
          <h3 className="text-3xl md:text-5xl font-serif font-black tracking-wide" data-id="element-144">
            NO TENÉS QUE RESIGNARTE A ESO.
          </h3>
        </motion.div>
      </div>
    </section>;
}